/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디 
 * - sponserName: 후원인 이름 
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성 
 */

import GentleWidget from '../common/widget';
import GentleUtil from '../common/util';
import GentleApi from '../common/api';
import GentleComponentButton from '../component/button';
import GentleComponentBubble from '../component/bubble';
import GentleComponentQuickReply from '../component/quickReply';
import GentleLang from '../common/lang';
import GentleProxy from '../common/proxy';
import ConstValue from '../common/const';
import GentleServiceProfile from '../service/profile';
import GentleAppState from '../common/appstate';
import GentleServiceProduct from '../service/product';
import GentleComponentTimeStamp from '../component/timeStamp';
import GentleServiceHome from '../service/home';
import language from '../lang';
import GentleServiceOrder from './order';

var GentleServiceAccount = Object.create( GentleWidget,{
    sponserId:{ writable: true, configurable: false, enumerable: true},
    sponserName: { writable: true, configurable: false, enumerable: true}
})

GentleServiceAccount.noLogin = function(data){
}
GentleServiceAccount.login = function (json) {
    //로그인 id, pw 로 토큰받아오기.
    //토큰받아온것으로 유저정보 확인(iframe function)
    // const {fallback, proxy, nextService} = json;
    const {fallback, proxy} = json;
    const nextService = localStorage.getItem(ConstValue.Storage.service);

    // 권한이 없는 상태에서 로그인베이스 서비스를 호출했는지 여부 
    const isFallback = (fallback !== undefined && fallback == 'true') ? true : false;
    const name = GentleAppState.custName;

    localStorage.setItem(ConstValue.Storage.service, '');
    if(isFallback){
        // console.log('nextService', nextService);
        
        if(nextService){
            localStorage.setItem(ConstValue.Storage.service, nextService);
        }
    }

    if (!GentleAppState.isLogin) {
        // console.log('GentleServiceAccount.login');


        const component = Object.create(this);

        // console.log('GentleAppState>', GentleAppState);

        let $warning;
        const request = function (UserId, Password) {
            // window.ChatConsole.loadingBox(true);
            GentleUtil.serviceLoadingShow();

            const onSuccess = function (data) {
                console.log('onSuccess>', data);
                
                // switch (data.Status) {
                //     case 1:
                //         location.reload();
                //         GentleServiceAccount.ssoCheck(data.value.token);

                //         break;
                //     default:
                //         // console.log('실패');
                //         $warning.css('display', 'block');
                //         $warning.html(GentleLang.translateService(language.account, language.account.type.CheckIt));
                // }

                // 2025 로그인 성공시
                if(data.result === '200'){
                    console.log('로그인 성공');
                    // location.reload();

                    const {item} = data;
                    const {userToken} = item;
                    console.log('item>', item);
                    GentleServiceAccount.ssoCheck(userToken);
                }
                else{
                    console.log('로그인 실패');
                    $warning.css('display', 'block');
                    $warning.html(GentleLang.translateService(language.account, language.account.type.CheckIt));
                }

            };
            const onFailed = function (data) {
                console.log('onFailed');
            }

            const proxy = Object.create(GentleProxy);

            // --> 2025 로그인
            const body = {
                id: UserId,
                password: Password
            };
            proxy.requestEx( {proxy:"2025-login", param:body, onSuccess, onFailed, isHidden: true} );
        }

        const render = function () {
            // 봇버블
            {
                // 로그인이 베이스 서비스를 비로그인 상태에서 접근시 버블멘트 분기로직
                const bubbleText = (isFallback === true) ? 
                GentleLang.translateService(language.account, language.account.type.NoLogin) 
                : GentleLang.translateService(language.account, language.account.type.LoginBot);
                // console.log(bubbleText);

                var bubble = Object.create(GentleComponentBubble);
                bubble.createComponent({
                    "html": bubbleText,
                });
                bubble.insert();
            }

            // form
            {
                const placeholderId = GentleLang.translateService(language.account, language.account.type.PlaceholderId);
                const placeholderPw = GentleLang.translateService(language.account, language.account.type.PlaceholderPw);
                const button_title = GentleLang.translateService(language.account, language.account.type.ButtonLogin);
                const login_title = GentleLang.translateService(language.account, language.account.type.LoginTitle);

                let button_nomember = '';
                // if('orders' === json.proxy)
                const next = localStorage.getItem(ConstValue.Storage.service);
                if('GentleServiceOrder.main' === next)
                { // 주문내역조회
                    const nomember_title = GentleLang.translateService(language.account, language.account.type.NomemberTitle);
                    button_nomember = `<button type="button" name="button_nomember" class="primary default">${nomember_title}</button>`;
                }
                const html = `
                <div class="card-view">
                    <form class="service-form">
                        <h3 class="service-title">${login_title}</h3>
                        <input type = "text" placeholder="${placeholderId}" name="userid">
                        <input type = "password" placeholder="${placeholderPw}" name="password">
                        <hr class="mt-10">
                        <p class="info warning" style="display:none"></p>
                        <div class="gentle-button-group">
                            <div class="wide-button">
                                <button type="button" name="button_login" class="primary disabled">${button_title}</button>
                                ${button_nomember}
                            </div>
                        </div>
                    </form>
                </div>`;

                let $container = $(html)
                component.setPrefix("login");
                component.init($container);
                component.insert();

                // bind
                const $userid = component.find('[name="userid"]');
                const $password = component.find('[name="password"]');
                const $button = component.find('[name="button_login"]');
                const $buttonNomember = component.find('[name="button_nomember"]');
                // const $button = component.find('button');
                $warning = component.find('.info');

                const doLogin = function(){
                    const userid = $userid.val();
                    const password = $password.val();
                    $userid.val('');
                    $password.val('');
                    $warning.css('display', 'none');

                    // console.log('login : ', userid, password);
                    request(userid, password);
                }

                const validate = function (key) {
                    // console.log('validate>', key);

                    if (
                        $userid.val() === '' ||
                        $password.val() === ''
                    ) 
                    {
                        $button.removeClass('default');
                        $button.addClass('disabled');
                    } else 
                    {
                        $button.removeClass('disabled');
                        $button.addClass('default');

                        if(key.keyCode === 13){
                            // console.log('enter');

                            doLogin();
                        }
                    }
                };

                // Atomy Rule에 의한 Padding
                $userid.blur(function(){
                    GentleUtil.fillAuto($userid);
                });
                
                // Validation 
                $userid.keyup(validate);
                $password.keyup(validate);

                // ...
                // component.find('button').bind('click',
                $button.bind('click',
                    function () {
                        // console.log('click');
                        doLogin();
                    }
                );

                $buttonNomember.bind('click',
                function () {
                    GentleServiceOrder.nomembers();
                    // console.log('nomember', json.proxy);
                    // if('orders' === json.proxy)
                    // {
                    //     GentleServiceOrder.nomembers();
                    // }
                }
            );

            }
            GentleUtil.timeStamp();
        };
        render(json);
    }else{
        const lang = GentleAppState.lang.toUpperCase();             
    // 봇버블
    
        const string = {
            tomy: {
                kr: {
                    whatLevelupMerit: '물론이죠! 우리 회원님의 승급을 축하하는 프로모션을 드립니다. 애터미 제품 제공부터 현금, 자동차, 가족 해외 여행권까지 다양해요.'
                },
                eng: {
                    whatLevelupMerit: "Sure! We have a promotion to celebrate our member's promotion. They range from offering Atomy products to cash, cars, and overseas travel vouchers for families."
                }
            },
            papa:{
                kr: {
                whatLevelupMerit: '그럼요^^ 우리 회원님의 승급을 축하하는 프로모션을 드립니다. 애터미 제품 제공부터 현금, 자동차, 가족 해외 여행권까지 다양해요.'
                },
                eng: {
                whatLevelupMerit: "That's right ^^ We're giving away a promotion to celebrate our member's promotion. They range from offering Atomy products to cash, cars, and overseas travel vouchers for families."
                }
            }
        }

        // 봇버블
        let html;
        const persona = GentleAppState.persona;
        {
        html = GentleLang.translateService(language.account, language.account.type.LoginTwice, {name});
        var bubble = Object.create( GentleComponentBubble );   
        bubble.createComponent({
                html,
        });
        bubble.insert();
    }

    // button
    {
        const text = GentleLang.translateService(language.account, language.account.type.LowerLogin);
        const option = [
            {
                isHidden: true, 
                send: false,
                text: text,
                user: 'user',
                onClick: function () {
                    GentleServiceAccount.lowerList();
                },
            },
        ]
        var button = Object.create( GentleComponentButton);
        button.createComponent(option);
        button.insert();
    }    
    }
}

GentleServiceAccount.info = function(data){
    const component =  Object.create(this);
    const api = Object.create(GentleApi);
    api.onSuccess(function(data){
        // console.log('onSuccess>', data);
        const {Data} = data;
        render(Data);
    })

    api.onFailed(function(data){
        console.log('onFailed');
        api.successCallback(data);
    });
    api.url = 'http://localhost/';

    const payload = {
        comment: '인기상품주세요',
    };
    api.requestBody = payload;
    api.send();

    const render = function(data){
        // 봇버블
        {
            var bubble = Object.create( GentleComponentBubble );   
            const props = {name: '미경', family: '이'} // todo 
            const html = GentleLang.translateService(language.account, language.account.type.InfoBot1, props);
            bubble.createComponent({
                    "html": GentleLang.translateService(language.account, language.account.type.InfoBot1),
            });     
            bubble.insert();     
        }

        // 직급내역
        const type = 1; // todo : 조회조건
        // 1 : 15일, 말일 포함 전후 3일(영업일 기준)에 09:00:00~ 11:59:59 혹은 22:00:00 ~ 23:59:59 내 챗봇 진입
        // 2 : 15일, 말일 포함 전후 3일(영업일 기준) 외에 09:00:00~ 11:59:59 혹은 22:00:00 ~ 23:59:59 내 챗봇 진입
        // 3 :  00:00:00 ~ 07:59:59 혹은 10:00:00 ~ 20:25:59 내 챗봇 진입 

        if(type === 1) // 15일, 말일 포함 전후 3일(영업일 기준)에 09:00:00~ 11:59:59 혹은 22:00:00 ~ 23:59:59 내 챗봇 진입
        {
            /**
            me: {
                date: '2021-03-15',
                sales: "100",
                position:'샤론로즈마스터',
                left: '80000',
                right: '30000',
             */
            const html_template = `\
            <div style="border:solid 1px red">\
                <div>${data.me.date}</div>\
                <div>${data.me.sales}</div>\
                <div>${data.me.positon}</div>\
                <div>${data.me.left} | ${data.me.right}</div>\
            </div>`;

            component.insertElement($(html_template));            
        }

        // 후원수당
        if(type === 1 || type === 2)
        {

        }
        else if(type === 3)
        {

        }

        // QuickReply 상품검색, 신상품
        {
            const newProduct = function(){
                console.log('new Product')
            };
        
            const option = [
                {
                    title: '소실적 맞춤상품 추천',
                    text: '소실적 맞춤상품 추천',
                    user: 'user'
                },
            ]

            if(!isAll){
                option.push(
                    {
                        title: '후원수당과 발생내역',
                        text: '후원수당과 발생내역',
                        user: 'user'
                    },    
                )
            }

            var quickReply = Object.create( GentleComponentQuickReply);
            quickReply.createComponent(option);
        
            quickReply.insert();
        }
        GentleUtil.timeStamp();
    };
}

// 하위멤버 검색/선택
GentleServiceAccount.lowerList = function(){    
    // console.log('GentleServiceAccount.lowerList');
    //20221017
    // GentleUtil.updateSSOToken();

    const cards = [];   // element array
    let $list;  // 목록
    let $input_search;  // 검색 입력필드
    let $total;
    let $button_more;
    let $notice;
    let $button_group;

    let curPage = 0;
    let SearchKeyword = '';
    let TotalCount = 0;
    let $popup;   // 팝업안내 영역

    let rows = [];    // 화면에 로딩된 레코드 배열

    const updateCount = function(count, total){
        $total.html(GentleLang.translateService(language.account, language.account.type.TotalIndex, {count, total}));

    }
    
    const updateMoreButton = function(enable){
        $button_more.addClass('show');

        if(enable)
        {
            $button_more.removeClass('disabled');
            $button_more.addClass('default');    
        }else{
            $button_more.removeClass('default');
            $button_more.addClass('disabled');
        }
    }

    const updateView = function(data){
        console.log('updateView>', data);
        const { items:List, currentPage:PageNo } = data;

        if(List && List.length > 0){            
            $notice.addClass('remove');
            curPage = PageNo;
            TotalCount = data.totalCount;

            addCard(List);
            rows = rows.concat(List);

            updateCount(rows.length, TotalCount);
            updateMoreButton(rows.length < TotalCount);
        }
        else{
            $notice.addClass('show');

            const text = GentleLang.translateService(language.account, language.account.type.NotFound); 
            $notice.html(text)
            
            console.log($button_group);
            $button_group.addClass('hide');                    
        }
    }

    // 관심회원 목록
    const request = function(PageNo){
        GentleUtil.serviceLoadingShow();

        const loading = Object.create( GentleComponentBubble );   
        loading.createComponent({"loading": true});
        loading.insert();    

        const onSuccess = function(data){            
            console.log('onSuccess>', data);

            loading.remove();

            switch(data.result){
            case '200':
                updateView(data);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');
            loading.remove();

            // onSuccess(dummy);
        }

        const proxy = Object.create(GentleProxy);
        const param = {PageNo, SearchKeyword:''};
        // proxy.request( "interestMember", param, onSuccess, onFailed );
        proxy.request( "2025-interestMember", param, onSuccess, onFailed );
    }

    const search = function(PageNo){
        GentleUtil.serviceLoadingShow();
        const onSuccess = function(data){
            console.log('onSuccess>', data);
            switch(data.Status){
            case 1:
                data.PageNo = PageNo;
                updateView(data);
                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            console.log('onFailed');

            // onSuccess(dummy);
        }

        const proxy = Object.create(GentleProxy);

        // console.log('SearchKeyword'. SearchKeyword);
        const param = {
            PageNo,
            SearchKeyword,
        };
        proxy.request( "interestMember", param, onSuccess, onFailed );
    } 

    const resetCards = function(){
        cards.forEach(element => {
            element.css('background-color', 'white');
        });
    };

    const didClickStar = function(element){
        $popup.addClass('show');
        return true;
    }

    // 2025.2 관심회원 목록 조회
    const addCard = function(array){
        // let cardIndex = 0;
        array.forEach(element => {
            console.log('element > ', element);
            
            // 2022-api : 관심회원정보조회 구버전과 일치한다.
            
            let { PvStatus, CustName, CustNo, IsInterested } = element;
            const current = PvStatus.Current;
            const total = GentleUtil.comma(PvStatus.Total);

            const dateString = `${element.RegDate.substring(0,4)}.${element.RegDate.substring(4,6)}.${element.RegDate.substring(6,8)}`; // GentleUtil.dateString(element.RegDate);
            const titleCur = GentleLang.translateService(language.account, language.account.type.SalesCur); // '현재 매출'; 
            const titleTotal = GentleLang.translateService(language.account, language.account.type.SalesTotal); // '총 매출'

            const position = GentleLang.mastershipType(parseInt(element.CurrentMastership));

            {
                CustName = GentleUtil.maskingName(CustName);
                CustNo = GentleUtil.maskingNo(CustNo);
            }

            const on = IsInterested ? 'on' : '';

            let html = `
            <li>
                <div class="flex-box">
                    <h6>${CustName}</h6>
                    <i class="favorite ${on}" name="IsInterested"></i>
                </div>
                <p>${CustNo} | ${position} | ${dateString}</p>
                <div class="flex-box">
                    <span>${titleCur}</span>
                    <span><strong>${current}</strong> PV</span>
                </div>
                <div class="flex-box">
                    <span>${titleTotal}</span>
                    <span><strong>${total}</strong> PV</span>
                </div>
                <i class="floating at-check">하위회원선택</i>
            </li>            
            `
    
            const $card = $(html);

            // 첫번째 아이템 태깅
            //console.log(cardIndex);
            // if(++cardIndex === 1){
            //     $card.addClass('first-item');
            // }

            cards.push($card);

            $card.find('div').bind('click', function(){
                resetCards();
                // console.log(element);
                $card.css('background-color', 'red');
                GentleUtil.removeSlidePopup();

                const text = GentleLang.translateService(language.account, language.account.type.LowerLogin);
                GentleComponentBubble.insertUserBubble({html: text, send: false});

                GentleServiceAccount.lowerLogin(element);                
            });

            $card.find('[name="IsInterested"]').bind('click', function(event){
                didClickStar(element);

                event.stopPropagation();
            });

            $list.append($card);
        });       
    }

    const doSearch = function(text){
        // console.log('search : ', text);

        updateMoreButton(false);
        curPage = 0;
        TotalCount = 0;
        rows = [];
        updateCount(rows.length, TotalCount);
        SearchKeyword = text;

        $input_search.val('');
        // empty list
        {
            $list.empty();
            cards.splice(0,cards.length);
        }

        search(1);
    };

    const render = function(){
        const title = GentleLang.translateService(language.account, language.account.type.TitleChild) ; // 하위회원 선택
        const buttonMore = GentleLang.translate(GentleLang.type.ButtonMore);
        const titleMyMember = GentleLang.translate(GentleLang.type.MyMember);
        const commentFindMember = GentleLang.translateService(language.account, language.account.type.FindMember);
        const titleFavoriteSet = GentleLang.translateService(language.account, language.account.type.FavoriteSet);
        const favoriteInfo = GentleLang.translateService(language.account, language.account.type.FavoriteInfo);
        const buttonMemberSetting = GentleLang.translateService(language.account, language.account.type.MemberSetting);

        const total = GentleLang.translateService(language.account, language.account.type.TotalIndex, {count: rows.length, total: TotalCount});
        const placeholder = GentleLang.translateService(language.account, language.account.type.PlaceholderSearch);
        const info = GentleLang.translateService(language.account, language.account.type.Info);

        let html = `
        <div id="child-member-select">
            <div class="search-field-container">
                <div class="search-field">
                    <input type="text" placeholder="${placeholder}">
                    <i class="at-icon at-search at-3x"></i>
                </div>
            </div>
            <p class="info-box"><img src="/assets/images/atomy/popup_informatino.png" srcset="/assets/images/atomy/popup_informatino@2x.png 2x">${info}</p>
            <div id="child-member-content">
                <div class="flex-box space-between">
                    <span>${titleMyMember}</span>
                    <span name="total">${total}</span>
                </div>
                <hr class="mt-20">
                <ul class = "card-list child-member" name="list">
                </ul>
            </div>
            <p class="notice" name="notice">${commentFindMember}</p>
            <div class="gentle-button-group" name="button-group">
                <div class="wide-button">
                    <button type="button" class="primary default" name="more">${buttonMore}</button>
                </div>
            </div>

            <div class="popup-information" name="popup">
                <header>
                    <h3>${titleFavoriteSet}</h3>
                    <i class="at-icon at-close" onClick="document.querySelector('#child-member-select .popup-information').classList.remove('show')" style="cursor:pointer"></i>
                </header>
                <section>
                        <p>
                            ${favoriteInfo}
                        </p>
                        <div class="gentle-button-group" >
                            <div class="wide-button">
                                <button type="button" class="primary default" name="goSetting">${buttonMemberSetting}</button>
                            </div>
                        </div>
                </section>
            </div>
        </div>            `

        let $container = $(html)

        // bind
        {
            $list = $container.find('[name="list"]');
            $total = $container.find('[name="total"');
            $button_more = $container.find('[name="more"]');
            $button_group = $container.find('[name="button-group"]');
            
            $popup = $container.find('[name="popup"]');
            $notice = $container.find('[name="notice"]');
        }

        // 검색버튼
        {
            $input_search = $container.find('input');

            $input_search.keydown(function(key) {
                if (key.keyCode == 13) {
                    const text = $input_search.val();
                    doSearch(text);
                    $input_search.val('');
                    $input_search.attr("readonly",true);
                    $input_search.focus();
                    setTimeout(function(){ $input_search.attr("readonly",false);}, 50);
                }
            });
        }

        // 관심회원 설정하러 가기
        $container.find('[name="goSetting"]').bind('click',
            function(event) {
                // console.log('설정하러 가기 > 웹');
                let Url = language.url.mobile.InterestedMemberSet;
                GentleUtil.ssoOpen(Url); 
                event.stopPropagation();
            }
        );

        // 더보기
        const doMore = function() {
            // console.log('더보기>', SearchKeyword)
            if(SearchKeyword === ''){
                request(curPage + 1);
            }
            else{
                search(curPage + 1);
            }
        }

        $container.find('[name="more"]').bind('click',
            doMore
        );

        GentleUtil.createSlidePopup({
            title, content: $container, 
            autoHeight: 'fix',
            bgColor: "#f2f5f7",
            headerBgColor: '#fff'
        });
    };

    render();
    request(1);
}

GentleServiceAccount.lowerLogin = function(data){
    console.log('GentleServiceAccount.lowerLogin>', data);
    const component =  Object.create(this);
    {
        let $userBubbles = GentleAppState.$chatConsoleSelector.find(".speech-bubble.user");
        let $chatConsoleBottomSelector = GentleUtil.$chatConsoleBottomSelector

        // Scroll에 필요한 값들을 계산
        let $lastUserBubble = $userBubbles.last();
        let coversationRootHeight = GentleAppState.$conversationRoot.height();
        let chatConsoleHeight = GentleAppState.$chatConsoleSelector.height();
        let lastUserBubbleTop = $lastUserBubble.position().top;
        let middleResult = (chatConsoleHeight - lastUserBubbleTop);
        let chatConstoleBottomCalc = coversationRootHeight - Math.abs(middleResult);
        console.log($lastUserBubble)
        console.log(coversationRootHeight)
        console.log(chatConsoleHeight)
        console.log(lastUserBubbleTop)
        console.log(chatConstoleBottomCalc)

        // 챗콘솔 하단 여백 조정 
        $chatConsoleBottomSelector.css('height', chatConstoleBottomCalc+'px');
        
        // 마지막 유저 버블 위치로 이동 
        GentleAppState.$conversationRoot.animate({scrollTop: lastUserBubbleTop}, 700);
    }

    // element
    let $password;  // 비번
    let $comment;
    let button_reselect;    // 계정 다시 선택하기

    // api
    const request = function(UserId){
        const Password = $password.val().trim();
        if(Password ==''){
            $comment.html(`*${GentleLang.translateService(language.account, language.account.type.Placeholder)}`);
            return;
        }
        // button_reselect.$elem.hide();
        // console.log('이 계정으로 로그인하기', UserId, Password);

        const proxy = Object.create(GentleProxy);
        const body = {UserId, Password};
        const onSuccess = function(data){
            // console.log('onSuccess>', data);
            switch(data.Status){
                case 1: // 로그인 하는 경우
                    $comment.html(``);
                    // console.log('로그인 성공');
                  
                    const url = '';                            
                    window.location = url; // 풀어야 한다.
                    break;
                default:
                    // console.log('실패');
                    $comment.css('display', 'block');                                    
                    $comment.html(GentleLang.translateService(language.account, language.account.type.CheckIt));
                }

        };

        GentleUtil.serviceLoadingShow();

        // proxy.request( "login", body, onSuccess );
        proxy.requestEx( {proxy:"login", param:body, onSuccess, isHidden: true} );
    }

    const render = function(data){
        // console.log('render>', data);
        // 봇버블
        {
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    "html": GentleLang.translateService(language.account, language.account.type.SelectLoginBot),
            });     
            bubble.insert();
        }

        // 카드
        {
            // console.log('card', data);
            const placeholder = GentleLang.translateService(language.account, language.account.type.Placeholder) ; // 하위회원 선택
            const button_title = GentleLang.translateService(language.account, language.account.type.ButtonSelectLogin);
            const selectLogin = GentleLang.translateService(language.account, language.account.type.SelectLogin);

            const {CustImg, CustName, CustNo} = data;
            let custImg = CustImg;

            if(CustImg){

            }
            else{
                const arr = window.location.href.split('/');
                if(arr[2] === 'localhost:8080'){
                    arr[2] = 'chat-dev.atomy.kr';
                }
                custImg = `${arr[0]}//${arr[1]}${arr[2]}/assets/images/atomy/profile_atomy.png`;
            }

            const name = GentleUtil.maskingName(CustName);
            const no = GentleUtil.maskingNo(CustNo);

            let html = `
            <div class="card-view">
                <form class="service-form">
                    <h3>${selectLogin}</h3>
                    <div class="login-profile">
                        <figure>
                            <img src = "${custImg}">
                        </figure>
                        <div>
                            <h6>${name}</h6>
                            <p>${no}</p>        
                        </div>
                    </div>
                    <input type = "hidden" name="user_id" value="${no}" class="disabled" readonly>
                    <input type = "password" name="password" placeholder="${placeholder}">
                    <hr class="mt-10">
                    <p class="info warning" style="display:none" name="comment"></p>
                    <div class="gentle-button-group" name="button-group">
                        <div class="wide-button">
                            <button type="button" class="primary disabled">${button_title}</button>
                        </div>
                    </div>
                </form>
            </div>`

            component.setPrefix("lowerLogin");
            component.init($(html));
            component.insert();

            // bind
            const $button = component.find('button');
            const validate = function(event) {
                if(
                    $password.val() === ''
                ){
                    $button.removeClass('default');
                    $button.addClass('disabled');
                }
                else{
                    $button.removeClass('disabled');
                    $button.addClass('default');
                }
            };

            $password = component.find('[name="password"]');
            $password.keyup(validate);
            $password.keydown(function(event) {
                if(event.keyCode == 13) {
                    event.preventDefault();
                    request(CustNo);
                }
            });

            $comment = component.find('[name="comment"]');

            // 로그인
            $button.bind('click',
                function() {
                    request(CustNo);
                }
            );
        }

        // 버튼
        {
            const text = GentleLang.translateService(language.account, language.account.type.Reselect);
            const option = [
                {
                    isHidden: true,
                    text,
                    isCardWidth: true,
                    user: 'user',
                    onClick: function(){
                        // console.log('계정 다시 선택하기')
                        GentleServiceAccount.lowerList();
                    }
                },
            ]
            button_reselect = Object.create( GentleComponentButton);
            button_reselect.createComponent(option);
            button_reselect.insert();
        }
        GentleUtil.timeStamp();
    };

    render(data);
}

// 로그아웃 발화
GentleServiceAccount.logoutEntry = function(json){    
    const render = function(){
        // 봇버블
        {
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    "html": GentleLang.translateService(language.account, language.account.type.LowerLoginBot),
            });
            bubble.insert();
        }

        // button
        {
            const option = [
                {
                    isHidden: true,
                    text: GentleLang.translateService(language.account, language.account.type.LowerLogin),
                    user: 'user',
                    onClick: function(){
                        // console.log('하위회원으로 로그인하기');
                        GentleServiceAccount.lowerList();
                    },
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }
        {
            const handler = function(){
                // console.log('현재 계정에서 로그아웃하기');
                // todo : logout
                // 로그아웃 후 
                GentleServiceAccount.logout(json);
                // document.getElementById('iframeSSOProcess').contentWindow.postMessage(
                //     {
                //       key: 'removeSSOToken',
                //       msg: '',
                //       from: 'parent',
                //       to: 'iframe',
                //     }, 'https://dev-api.atomyn.kr')

            };

            const option = [
                {
                    send: false,
                    text: GentleLang.translateService(language.account, language.account.type.Logout),
                    user: 'user',
                    onClick: handler,
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }

        // timestamp
        GentleUtil.timeStamp();
    }
    render();
}

GentleServiceAccount.ssoCheck = function(token){
    console.log('GentleServiceAccount.ssoCheck>', token);
    const request = function(){
        const onSuccess = function(data){
            // console.log("entleServiceAccount.ssoCheck.data", data)
            switch (data.Status) {
                case '1':
                    // console.log('로그인 성공');
                    // const {Data} = data;
                    // GentleServiceAccount.settingToken()
                    location.reload();
                    break;
                case '50':
                    console.log('status:50 로그인 실패')
                    break;
                default:
                    // console.log('실패');
                    // $warning.css('display', 'block');
                    // $warning.html(GentleLang.translateService(language.account, language.account.type.CheckIt));
            }
        };
    
        const onFailed = function(data){
            // console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {token};
        // console.log("sso-check in, param ==>", param)
        proxy.requestEx({proxy:"sso-check", param, onSuccess, onFailed, isHidden:true })
    }

    request();
}


GentleServiceAccount.logout = function(json){
    const logout = function(){
        const onSuccess = function(data){
            // console.log('onSuccess>', data);
            switch(data.Status){
            case '1':
            case '90':
                const { Data } = data;
                // console.log('Data>', Data);

                // GentleServiceHome.main();
                location.reload();

                break;
            default:
                break;
            }
        };
    
        const onFailed = function(data){
            // console.log('onFailed');
        }

        const proxy = Object.create(GentleProxy);
        const param = {};
        // proxy.request("logout", param, onSuccess, onFailed );
        proxy.requestEx({proxy:"logout", param, onSuccess, onFailed, isHidden:true });
    }

    const render = function(){
        // 봇버블
        {
            var bubble = Object.create( GentleComponentBubble );   
            bubble.createComponent({
                    "html": GentleLang.translateService(language.account, language.account.type.LogoutBot),
            });
            bubble.insert();
        }

        // button
        {
            const handler = function(){
                // console.log('로그아웃');
                // todo : logout
                document.getElementById('iframeSSOProcess').contentWindow.postMessage(
                    {
                      key: 'removeSSOToken',
                      msg: '',
                      from: 'parent',
                      to: 'iframe',
                    }, 'https://shop-api-ga.atomy.com/')
                    // }, 'https://dev-api.atomyn.kr') //개발
                // }, 'http://localhost:3000') //로컬
                logout();
            };

            const option = [
                {
                    send: false,
                    text: GentleLang.translateService(language.account, language.account.type.ButtonLogout),
                    user: 'user',
                    onClick: handler,
                },
            ]
            var button = Object.create( GentleComponentButton);
            button.createComponent(option);
            button.insert();
        }   
        GentleUtil.timeStamp(); 
    }

    render();
}


export default GentleServiceAccount;